import type { ProductLinkTarget, SanityLink, SanityLinkOptional } from '../product-variant.types';
import { shouldOpenInNewTab } from '@workspace/lib';

/**
 * Maps a Sanity link (link or linkOptional) to ProductLinkTarget
 */
export const mapLink = (link: SanityLink | SanityLinkOptional | undefined | null): ProductLinkTarget | undefined => {
  if (!link) return undefined;

  const href = link.url;
  if (!href) return undefined;

  const newTab = shouldOpenInNewTab(link);
  return {
    href,
    newTab,
    type: link.type,
  };
};
